<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>流程</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="main_list">
            <div class="flex">
                <div class="main_header_btns">
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                class="procedure"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%" :width="scope.row.width">
                            <div v-if="item.prop == 'rel_name'">
                                <el-link type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <span v-else> {{ scope.row[item.prop] }} </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize } from '../../../../js/common';
import draggableList from '../../../common/Drawer.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList
    },
    name: 'processRulesComponent',
    data() {
        return {
            draggable: {
                data_name: 'procedure'
            },
            parentOptions: [],
            down_loading: false,
            updateLoading: false,
            tableData: [],
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            sort: '', //排序参数
            data_name: '', //排序参数
            loading: true
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        //详情内调用不用本地存储的params
        if (!this.postList.params) {
            //列表页面调用 优先取本地存储
            var paramsList = JSON.parse(localStorage.getItem('paramsList'));
            if (paramsList['process_params']) {
                this.page = paramsList['process_params'].page;
                this.row = paramsList['process_params'].row;
                // this.data_name = paramsList['process_params'].data_name;
                // this.sort = paramsList['process_params'].sort;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.row = 10;
                this.getList(0); //获取列表
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('procedure', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).procedure;
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['process_params']) {
                    newParamsList['process_params'].data_name = val.prop;
                    newParamsList['process_params'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //跳转详情
        handleClick(row, prop) {
            if (prop == 'rel_name') {
                this.$router.push({
                    path: '/processDetails',
                    query: {
                        rel_type: row.rel_type
                    }
                });
            }
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row
            };
            //当点击 或者触发回车事件保存参数
            if (type == 1) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                newParamsList['process_params'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            if (type_data == 0) {
                this.loading = true;
                this.$api
                    .procedureLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                newParamsList['process_params'].page = res.data.last_page;
                                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                this.page = res.data.last_page;
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        
                    });
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['process_params']) {
                    newParamsList['process_params'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['process_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当页数发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['process_params']) {
                    newParamsList['process_params'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['process_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>